import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import ChemDrawStoichiometryTable from 'chemistry/ChemDrawStoichiometryTable';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import CaptionEditableClass from 'notebook/mediocre/base-plugin/CaptionEditable';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import formatters from 'notebook/mediocre/formatted-text/formatters';
import NoteLinkedFilePreview from 'notebook/notes/attachments/NoteLinkedFilePreview';
import {NoteEditor, NoteEditorProps} from 'notebook/notes/NoteEditorTypes';
import {previewPlugin, PreviewPluginItemProps} from 'notebook/notes/previews/PreviewPluginFactory';
import {NoteLinkedFile, NotePart} from 'notebook/util/NoteUtilConstants';

const ATTACHMENT_PREVIEW_PLUGIN = previewPlugin({
  type: ModelTypeConstants.NOTE_LINKED_FILE,
  preview: NoteLinkedFilePreview,
  renderFooter(
    editor: NoteEditor,
    item: NotePart & {item: NoteLinkedFile},
    index: number,
    editorProps: NoteEditorProps,
    itemProps: PreviewPluginItemProps
  ): JSX.Element | null {
    // TODO(saif): this plugin should expose an extension point that a chemistry plugin can hook into.
    if (
      BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE &&
      item.item &&
      item.item.externalFile &&
      item.item.externalFile.url.endsWith('.cdxml')
    ) {
      return (
        <ChemDrawStoichiometryTable
          noteLinkedObjectId={itemProps.itemId!}
          noteLinkedObjectCid={item.item.cid}
          indentation={editor.getIndentation(item)}
          onSelectTable={() => {
            editorProps.requestSelection({
              selection: {
                cid: CaptionEditableClass.getAttachmentCid(item.cid),
                start: 0,
                end: 0,
              },
            });
          }}
        />
      );
    } else {
      return null;
    }
  },
});

export default ATTACHMENT_PREVIEW_PLUGIN;
